<template>
    <div class="AudioPlayer">
        <audio controls>
            <source
                :src="audio"
                type="audio/mpeg"
            >
        </audio>
    </div>
</template>

<script>
import store from '@/store/store';

export default {
    props: {
        namespace: {
            type: String,
            required: true,
        }
    },

    computed: {
        audio() {
            return store.state[this.namespace].options.audio;
        },
    },
};
</script>

<style lang="scss">
.AudioPlayer {
    flex: 0 0 100%;
    width: 100%;

    padding: 18px !important;

    @media (min-width: 600px) {
        padding: 12px 24px !important;
    }

    @media (min-width: 768px) {
        padding: 12px 36px !important;
    }

    audio {
        width: 100% !important;
    }
}
</style>
